import { supabase } from "../supabase/client";

export type GoalsGraphProfile = {
  id: string;
  name: string;
  nodes: any[];
  edges: any[];
  createdAt: number;
};

type DbGoalsGraphProfile = {
  id: string;
  name: string;
  nodes: any;
  edges: any;
  created_at: string;
};

export const GOALS_GRAPH_PROFILES_CHANGED_EVENT = "goalsGraphProfiles:changed";

export const notifyGoalsGraphProfilesChanged = () => {
  window.dispatchEvent(new Event(GOALS_GRAPH_PROFILES_CHANGED_EVENT));
};

export const onGoalsGraphProfilesChanged = (handler: () => void) => {
  window.addEventListener(GOALS_GRAPH_PROFILES_CHANGED_EVENT, handler);
  return () =>
    window.removeEventListener(GOALS_GRAPH_PROFILES_CHANGED_EVENT, handler);
};

const mapDbToProfile = (row: DbGoalsGraphProfile): GoalsGraphProfile => {
  return {
    id: row.id,
    name: row.name,
    nodes: Array.isArray(row.nodes) ? row.nodes : [],
    edges: Array.isArray(row.edges) ? row.edges : [],
    createdAt: Number.isFinite(Date.parse(row.created_at))
      ? Date.parse(row.created_at)
      : Date.now(),
  };
};

export const goalsGraphProfilesDB = {
  getAll: async (): Promise<GoalsGraphProfile[]> => {
    const { data, error } = await supabase
      .from("goals_graph_profiles")
      .select("id,name,nodes,edges,created_at")
      .order("created_at", { ascending: true });
    if (error) {
      console.error("[goalsGraphProfilesDB] getAll failed", error);
      return [];
    }
    return (data || []).map(mapDbToProfile);
  },

  upsert: async (
    profile: GoalsGraphProfile
  ): Promise<GoalsGraphProfile | null> => {
    const { data, error } = await supabase
      .from("goals_graph_profiles")
      .upsert(
        [
          {
            id: profile.id,
            name: profile.name,
            nodes: profile.nodes,
            edges: profile.edges,
          },
        ],
        { onConflict: "id" }
      )
      .select("id,name,nodes,edges,created_at")
      .single();
    if (error) {
      console.error("[goalsGraphProfilesDB] upsert failed", error);
      return null;
    }
    notifyGoalsGraphProfilesChanged();
    return mapDbToProfile(data as DbGoalsGraphProfile);
  },

  delete: async (id: string): Promise<boolean> => {
    const { error } = await supabase
      .from("goals_graph_profiles")
      .delete()
      .eq("id", id);
    if (error) {
      console.error("[goalsGraphProfilesDB] delete failed", error);
      return false;
    }
    notifyGoalsGraphProfilesChanged();
    return true;
  },
};
